import { useQuery } from '@apollo/client';
import {
  GridContent,
  GridLayout,
  Heading,
  Page,
  PageBreadcrumb,
  PageContent,
  PageTitle,
  TextButton,
} from '@zillow/constellation';
import { EXTERNAL_URLS, getExternalUrl } from '../constants/urls';
import { GetApplicationsForUserDocument } from '../graphql/queries';
import { ApplicationsList } from '../components/ApplicationsList';
import { FullWidthPropertyCard } from '../styles/styled-components';

export default function ApplicationsPage() {
  const { loading, data } = useQuery(GetApplicationsForUserDocument, {
    variables: {
      includeSharedApplications: true,
    },
  });

  return (
    <Page backgroundColor="backgroundLight">
      <PageBreadcrumb
        backButton={
          <TextButton as="a" href={getExternalUrl(EXTERNAL_URLS.RENTER_HUB)}>
            Back to Renter Hub
          </TextButton>
        }
      />
      <PageTitle heading={<Heading level={1}>Your rental applications</Heading>}></PageTitle>
      <PageContent>
        <GridLayout>
          <GridContent gridColumnEnd="span 12">
            {data && <ApplicationsList data={data} />}
            {loading && !data && <ApplicationsLoading />}
          </GridContent>
        </GridLayout>
      </PageContent>
    </Page>
  );
}

function ApplicationsLoading() {
  return (
    <>
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
      <FullWidthPropertyCard appearance="horizontal" data={{}} loading marginBottom="sm" />
    </>
  );
}
